// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-joyride__spotlight {
  display: none;
}
.react-joyride__overlay {
  opacity: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home/components/Instruction/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ","sourcesContent":[".react-joyride__spotlight {\n  display: none;\n}\n.react-joyride__overlay {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
